// 帖子相关的 Action 层，负责业务逻辑和异步操作
import { action, makeObservable, runInAction } from 'mobx';
import { LotteryStore } from './store';
import { submitLotteryDraw, getLotteryActivities, getLotteryActivitiesTickets, getLotteryActivitiesRecords, getLotteryActivitiesInvitations, getLotteryActivitiesDraws, submitLotteryActivitiesOpenShare, getLotteryActivitiesSurprises, getLotteryActivitiesBarrage, submitLotteryOpenUrl } from '@server';


export class LotteryAction extends LotteryStore {

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    /**
     * 获取抽奖券记录列表（异步）
     * 统一管理 loading、错误、分页、hasMore 等状态
     * 页面和 list 组件可直接响应 listStore 的状态
     * @param {object} params 查询参数
     *   - params.page[number]: 页码
     *   - params.page[size]: 每页数量
     * @returns {Promise<void>}
     */


    @action
    async getLotteryActivitiesTicketsData(id, params) {
        runInAction(() => {
            this.listStore.setAttribute({ namespace: 'lotteryActivitiesTicketsList', key: 'loading', value: true });
        });
        const res = await getLotteryActivitiesTickets(id, params);
        runInAction(() => {
            // console.log(' list response:', res, 'Params:', params);
            if (res.code === 0) {
                // 适配新格式：数据在 res.data.data，分页在 res.data.page
                // const lotteryData = res.data && res.data.data ? res.data.data : res.data;
                const pageInfo = res.data && res.data.page ? res.data.page : {};
                
                this.listStore.setList({
                    namespace: 'lotteryActivitiesTicketsList',
                    data: {},
                    path: 'data',
                    page: params.page || params['page[number]'] || pageInfo.number || 1,
                    hasMore: pageInfo.hasMore !== undefined ? pageInfo.hasMore : false,
                });
                this.listStore.setAttribute({ namespace: 'lotteryActivitiesTicketsList', key: 'requestError', value: { isError: false, errorText: '' } });
            } else {
                this.listStore.setAttribute({ namespace: 'lotteryActivitiesTicketsList', key: 'requestError', value: { isError: true, errorText: res.message || '加载失败' } });
            }
            this.listStore.setAttribute({ namespace: 'lotteryActivitiesTicketsList', key: 'loading', value: false });
        });
        // console.log('这是列表呀', res);
        return res
    }

    /**
     * 直接设置 lotteryActivitiesTicketsList listStore 统一管理）
     * @param {array} lotteryActivitiesTicketsList 抽奖券记录列表
     */
    @action
    setLotteryActivitiesTicketsList(lotteryActivitiesTicketsList) {
        this.lotteryList = lotteryActivitiesTicketsList;
    }

    /**
     * 获取抽奖活动-邀请记录列表（异步）
     * 统一管理 loading、错误、分页、hasMore 等状态
     * 页面和 list 组件可直接响应 listStore 的状态
     * @param {object} params 查询参数
     *   - params.page[number]: 页码
     *   - params.page[size]: 每页数量
     * @returns {Promise<void>}
     */


    @action
    async getLotteryActivitiesInvitationsData(id, params) {
        runInAction(() => {
            this.listStore.setAttribute({ namespace: 'lotteryActivitiesInvitationsList', key: 'loading', value: true });
        });
        const res = await getLotteryActivitiesInvitations(id, params);
        runInAction(() => {
            // console.log(' list response:', res, 'Params:', params);
            if (res.code === 0) {
                // 适配新格式：数据在 res.data.data，分页在 res.data.page
                // const lotteryData = res.data && res.data.data ? res.data.data : res.data;
                const pageInfo = res.data && res.data.page ? res.data.page : {};
                
                this.listStore.setList({
                    namespace: 'lotteryActivitiesInvitationsList',
                    data: {},
                    path: 'data',
                    page: params.page || params['page[number]'] || pageInfo.number || 1,
                    hasMore: pageInfo.hasMore !== undefined ? pageInfo.hasMore : false,
                });
                this.listStore.setAttribute({ namespace: 'lotteryActivitiesInvitationsList', key: 'requestError', value: { isError: false, errorText: '' } });
            } else {
                this.listStore.setAttribute({ namespace: 'lotteryActivitiesInvitationsList', key: 'requestError', value: { isError: true, errorText: res.message || '加载失败' } });
            }
            this.listStore.setAttribute({ namespace: 'lotteryActivitiesInvitationsList', key: 'loading', value: false });
        });
        // console.log('这是列表呀', res);
        return res
    }

    /**
     * 直接设置 lotteryActivitiesInvitationsList listStore 统一管理）
     * @param {array} lotteryActivitiesInvitationsList 邀请记录列表
     */
    @action
    setLotteryActivitiesInvitationsList(lotteryActivitiesInvitationsList) {
        this.lotteryActivitiesInvitationsList = lotteryActivitiesInvitationsList;
    }

    /**
     * 获取抽奖活动-本次中奖记录列表（异步）
     * 统一管理 loading、错误、分页、hasMore 等状态
     * 页面和 list 组件可直接响应 listStore 的状态
     * @param {object} params 查询参数
     *   - params.page[number]: 页码
     *   - params.page[size]: 每页数量
     * @returns {Promise<void>}
     */

    @action
    async getLotteryActivitiesRecordsData(id, params) {
        runInAction(() => {
            this.listStore.setAttribute({ namespace: 'lotteryActivitiesRecordsList', key: 'loading', value: true });
        });
        const res = await getLotteryActivitiesRecords(id, params);
        runInAction(() => {
            // console.log(' list response:', res, 'Params:', params);
            if (res.code === 0) {
                // 适配新格式：数据在 res.data.data，分页在 res.data.page
                // const lotteryData = res.data && res.data.data ? res.data.data : res.data;
                const pageInfo = res.data && res.data.page ? res.data.page : {};
                
                this.listStore.setList({
                    namespace: 'lotteryActivitiesRecordsList',
                    data: {},
                    path: 'data',
                    page: params.page || params['page[number]'] || pageInfo.number || 1,
                    hasMore: pageInfo.hasMore !== undefined ? pageInfo.hasMore : false,
                });
                this.listStore.setAttribute({ namespace: 'lotteryActivitiesRecordsList', key: 'requestError', value: { isError: false, errorText: '' } });
            } else {
                this.listStore.setAttribute({ namespace: 'lotteryActivitiesRecordsList', key: 'requestError', value: { isError: true, errorText: res.message || '加载失败' } });
            }
            this.listStore.setAttribute({ namespace: 'lotteryActivitiesRecordsList', key: 'loading', value: false });
        });
        // console.log('这是列表呀', res);
        return res
    }

    /**
     * 直接设置 lotteryActivitiesRecordsData listStore 统一管理）
     * @param {array} lotteryActivitiesRecordsList 本次中奖记录列表
     */
    @action
    setLotteryActivitiesRecordsData(lotteryActivitiesRecordsList) {
        this.lotteryActivitiesRecordsList = lotteryActivitiesRecordsList;
    }


    /**
     * 获取抽奖活动-额外惊喜列表（异步）
     * 统一管理 loading、错误、分页、hasMore 等状态
     * 页面和 list 组件可直接响应 listStore 的状态
     * @param {object} params 查询参数
     *   - params.page[number]: 页码
     *   - params.page[size]: 每页数量
     * @returns {Promise<void>}
     */

    @action
    async getLotteryActivitiesSurprisesData(id, params) {
        runInAction(() => {
            this.listStore.setAttribute({ namespace: 'lotteryActivitiesSurprisesList', key: 'loading', value: true });
        });
        const res = await getLotteryActivitiesSurprises(id, params);
        runInAction(() => {
            // console.log(' list response:', res, 'Params:', params);
            if (res.code === 0) {
                // 适配新格式：数据在 res.data.data，分页在 res.data.page
                // const lotteryData = res.data && res.data.data ? res.data.data : res.data;
                const pageInfo = res.data && res.data.page ? res.data.page : {};
                
                this.listStore.setList({
                    namespace: 'lotteryActivitiesSurprisesList',
                    data: {},
                    path: 'data',
                    page: params.page || params['page[number]'] || pageInfo.number || 1,
                    hasMore: pageInfo.hasMore !== undefined ? pageInfo.hasMore : false,
                });
                this.listStore.setAttribute({ namespace: 'lotteryActivitiesSurprisesList', key: 'requestError', value: { isError: false, errorText: '' } });
            } else {
                this.listStore.setAttribute({ namespace: 'lotteryActivitiesSurprisesList', key: 'requestError', value: { isError: true, errorText: res.message || '加载失败' } });
            }
            this.listStore.setAttribute({ namespace: 'lotteryActivitiesSurprisesList', key: 'loading', value: false });
        });
        // console.log('这是列表呀', res);
        return res
    }

    /**
     * 直接设置 lotteryActivitiesSurprisesData listStore 统一管理）
     * @param {array} lotteryActivitiesSurprisesList 本次中奖记录列表
     */
    @action
    setLLotteryActivitiesSurprisesData(lotteryActivitiesSurprisesList) {
        this.lotteryActivitiesSurprisesList = lotteryActivitiesSurprisesList;
    }

    // 获取中奖弹幕
    async getLotteryActivitiesBarrageData(id) {
        const ret = await getLotteryActivitiesBarrage(id);
        return ret;
    }
    

    async getLotteryActivitiesData(id) {
        const ret = await getLotteryActivities(id);
        
        if (ret.code === 0) this.setLotteryData(ret.data);
        return ret;
    }

    /**
     * 设置 LotteryData
     * @param {object} data 详情数据
     */
    @action
    setLotteryData(data) {
        this.lotteryData = { ...this.lotteryData, ...data };
        this.lotteryData.id = data.id;
    }

    /**
     * 抽奖
     * @returns 抽奖信息
     */
    @action
    async submitLotteryDrawData(params = {}) {
        const ret = await submitLotteryDraw(params);
        
        if (ret.code === 0) this.setLotteryData(ret.data);
        return ret;
    }

    /**
     * 抽奖打开分享
     * @returns 分享信息
     */
    @action
    async submitLotteryActivitiesOpenShareData(params = {}) {
        const ret = await submitLotteryActivitiesOpenShare(params);
        return ret;
    }
    
    /**
     * 完成打开链接任务
     * @returns 结果
     */
    @action
    async submitLotteryOpenUrlData(params = {}) {
        const ret = await submitLotteryOpenUrl(params);
        return ret;
    }
    
    
}


// 单例导出，方便全局调用
const lotteryAction = new LotteryAction();
export default lotteryAction;